
import { getParams, serialize } from '../utility-functions/utility-functions';

export const clearOpenFilter = () => {
    sessionStorage.removeItem('openFilterDraw');
    sessionStorage.removeItem('openFilterPage');
};

export const saveOpenFilter = (reference: string, isDraw: boolean = true) => {
    const type = isDraw ? "Draw" : "Page";
    const filterString = `openFilter${type}`;    
    if ('sessionStorage' in window && reference != "SortBy") sessionStorage.setItem(filterString, reference);
};

export const getSavedOpenFilter = (isDraw: boolean = true) => {
    const type = isDraw ? "Draw" : "Page";
    const filterString = `openFilter${type}`
    return sessionStorage.getItem(filterString);
};

export const clearSavedScrollPosition = (forceClear = false) => {
    if (forceClear || ('sessionStorage' in window && !document.body.classList.contains('productPage'))) {
        sessionStorage.removeItem('scrollTo');
    }
};

export const saveScrollPosition = (reference) => {
    if ('sessionStorage' in window) sessionStorage.setItem('scrollTo', reference);
};


export const getSavedScrollPosition = () => {
    if ('sessionStorage' in window) {
        const scrollPosition = sessionStorage.getItem('scrollTo');
        sessionStorage.removeItem('scrollTo');
        return scrollPosition;
    }
};

export const getScrollToProductId = () => {
    let params = getParams(window.location.search);
    return params.scrollTo ? params.scrollTo : false;
};

export const removeScrollToProductId = () => {
    let params = getParams(window.location.search);
    delete params.scrollTo;
    const newParams = serialize({ ...params });
    if (newParams !== "?" && newParams !== "") {
        history.replaceState(null, null, serialize({ ...params }));
    }
};

export const updateUrl = (newParams) => {
    let existingParams = getParams(window.location.search);
    history.replaceState(null, null, serialize({ ...existingParams, ...newParams }));
};

